import { useEffect, memo, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './table.module.scss';
import cn from 'classnames';
import TableRow from '@components/checkListV2/tableRow';
import MoreActions from '@containers/MoreActions';
import { TableHead, TableRowActionButtons } from './constants';
import { ReactComponent as SortingIcon } from '@assets/images/sorting.svg';
import { SORT_ASC } from '../constants';
import { LABEL } from '@veriables';
import { flowType } from '@utility/userInfo';
import { APP_CONFIG } from '@constants';

const GRID = {
  gridTemplateColumns: '23% 15% 12% 12% auto',
};
const TableHeader = memo(({ serverAppTheme, sortColumn, activeSortKey, sortBy }) => (
  <div className={cn(styles.header, 'fs-12 pt-2')} style={GRID}>
    {TableHead.map(col => {
      const isActive = activeSortKey === col.sortKey;
      return col.isSort ? (
        <div key={col.key} className={cn(styles.unselected_filter, 'px-1')}>
          {col.name}
          <span
            role="presentation"
            className="position-relative float-right pr-1"
            style={{ color: serverAppTheme?.iconcolor, fontSize: '12px' }}
          >
            <div
              onClick={() => sortColumn(col.sortKey)}
              style={{
                display: 'inline-block',
                transform:
                  isActive && sortBy === SORT_ASC
                    ? 'scaleY(-1)'
                    : undefined,
                transition: 'transform 0.2s',
              }}
            >
              <SortingIcon
                fill={isActive ? serverAppTheme?.iconcolor : '#aaa'}
                alt="filter"
                className={cn(styles.filter_btn, 'mr-1')}
              />
            </div>
          </span>
        </div>
      ) : (
        <div key={col.key} className={cn(styles.unselected_filter, 'px-1')}>
          {col.name}
        </div>
      );
    })}
  </div>
));

const Table = ({
  paginatedData = [],
  serverAppTheme = {},
  onOrderClick,
  onPayClick,
  activeRow,
  setActiveRow,
  setSeat,
  sortColumn,
  activeSortKey,
  sortBy,
  onOpenPrint,
  isOnlyOrderMode
}) => {
  const navigate = useNavigate();
  const [moreActionsRow, setMoreActionsRow] = useState(null);
  const openTools = useCallback(row => setMoreActionsRow(row), []);
  const closeTools = useCallback(
    shouldRedirect => {
      setMoreActionsRow(null);
      if (shouldRedirect) {
        navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
          replace: true,
        });
      }
    },
    [navigate]
  );

  return (
    <>
      <TableHeader
        serverAppTheme={serverAppTheme}
        sortColumn={sortColumn}
        activeSortKey={activeSortKey}
        sortBy={sortBy}
      />
      {paginatedData?.length > 0 ? (
        paginatedData.map(row => (
          <TableRow
            key={row.id}
            row={row}
            gridStyle={GRID}
            tableRowActionButtons={TableRowActionButtons}
            serverAppTheme={serverAppTheme}
            onOrderClick={onOrderClick}
            onPayClick={onPayClick}
            isActiveRow={activeRow === row.id}
            setActiveRow={setActiveRow}
            setSeat={setSeat}
            isToolsOpen={moreActionsRow?.id === row.id}
            onToolsClick={openTools}
            onOpenPrint={onOpenPrint}
            isOnlyOrderMode={isOnlyOrderMode}
          />
        ))
      ) : (
        <div className="d-flex justify-content-center align-items-center h-95">
          <div
            className="text-center"
            style={{ color: serverAppTheme?.noRecord }}
          >
            <div className="fs_16 fw-400">{LABEL().NO_CHECKS}</div>
          </div>
        </div>
      )}
      {moreActionsRow && (
        <MoreActions
          serverAppTheme={serverAppTheme}
          isOpen={!!moreActionsRow}
          closeTools={closeTools}
          data={moreActionsRow}
        />
      )}
    </>
  );
};

const MemoizedTable = memo(Table);

export default MemoizedTable;
